import { motion } from "motion/react";

interface PricingSectionHeaderProps {
  title: string;
  subtitle: string;
}

export function PricingSectionHeader({ title, subtitle }: PricingSectionHeaderProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="text-center mb-12"
    >
      <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent">
        {title}
      </h2>
      <p className="text-gray-400 text-lg">{subtitle}</p>
    </motion.div>
  );
}